<template>
  <section>
    <div class="v2026-workarea" ref="workarea"
         :class="{ 'v2026-ladder-left-first': useLeftFirstCollapse, 'is-resizing': !!resizing }">
      <!-- Regions 2+3. display:contents on desktop, so the two columns stay independent flex
           children; below the ladder's drawer breakpoint this wrapper becomes the left drawer. -->
      <div class="v2026-mobile-nav" :class="{ 'is-open': mobileNavOpen }">
      <div class="v2026-col-queue" ref="colQueue" :style="queueColStyle"
           :class="{ 'is-collapsed': queueCollapsed }">
        <queue-menu-v2026 @onSearch="searchConversation"
                          @onReloadMenu="reloadCurrentMenu"
                          @onToggleQueue="toggleQueueCollapse"
                          :filteredMenuCount="filteredRecruitmentMenuCount"
                          ref="mainMenu"></queue-menu-v2026>
      </div>
      <div class="v2026-resizer" role="separator" aria-orientation="vertical"
           aria-label="ปรับความกว้างเมนูคิว"
           title="ลากเพื่อปรับความกว้าง (ดับเบิลคลิกเพื่อรีเซ็ต)"
           v-if="useColumnResizer && !queueCollapsed"
           @pointerdown="onResizeStart('queue', $event)"
           @pointermove="onResizeMove"
           @pointerup="onResizeEnd"
           @pointercancel="onResizeEnd"
           @dblclick="resetColWidth('queue')"></div>
      <div class="v2026-col-list" ref="colList" :style="listColStyle">
        <div class="v2026-list-title">
          <button v-if="queueCollapsed"
                  class="v2026-queue-expand"
                  @click="toggleQueueCollapse"
                  aria-label="แสดงรายการคิว"
                  title="แสดงรายการคิว">
            <span class="v2026-queue-expand-ico"></span>
          </button>
          <span>{{ listTitle }}</span>
        </div>
        <div v-if="menuType === 'reminder'" class="v2026-reminder-tabs" role="tablist">
          <button v-for="tab in reminderTabs" :key="tab.value"
                  type="button" role="tab"
                  class="v2026-reminder-tab"
                  :class="['is-' + tab.value, { 'is-active': reminderState === tab.value }]"
                  :aria-selected="reminderState === tab.value ? 'true' : 'false'"
                  @click="selectReminderState(tab.value)">
            {{ tab.label }}
            <span class="v2026-reminder-tab-count" v-if="tab.count">{{ tab.count }}</span>
          </button>
        </div>
        <div class="v2026-list-toolbar">
          <inbox-toolbar-v2026 ref="searchConversation"
                               :searchConversationParams="searchConversationParams"
                               @onSearch="searchConversation"
                               @onSortChange="reloadCurrentMenu"
                               @onUpdateActiveMenu="updateCountOfActiveMenu"></inbox-toolbar-v2026>
        </div>
        <div class="conversation-display v2026-list-scroll"
             ref="conversationDisplay" @scroll.passive="handleConversationScroll">
          <chat-card-v2026
            :key="customerType"
            :selectedConversation="selectedConversation"
            :conversations="conversations"
            :loading="conversationsLoading"
            :inlineStealthRead="useExtractedMainPanel"
            :stealthActiveConversation="incognitoConversation"
            :compact="useCompactCards && listCompact"
            @onStealthRead="openStealthInline"
            @onItemClick="loadConversationDetail"></chat-card-v2026>
        </div>
      </div>
      </div><!-- /v2026-mobile-nav -->
      <button v-if="!mobileNavOpen" class="v2026-mobile-nav-handle"
              @click="mobileNavOpen = true" aria-label="แสดงรายการแชท">
        <span class="v2026-mobile-nav-handle-glyph">☰</span>
        <span class="v2026-mobile-nav-handle-ico" aria-hidden="true"></span>
        <span class="v2026-mobile-nav-handle-label">รายการแชท</span>
      </button>
      <div class="v2026-resizer" role="separator" aria-orientation="vertical"
           aria-label="ปรับความกว้างรายการแชท" title="ลากเพื่อปรับความกว้าง (ดับเบิลคลิกเพื่อรีเซ็ต)"
           v-if="useColumnResizer"
           @pointerdown="onResizeStart('list', $event)"
           @pointermove="onResizeMove"
           @pointerup="onResizeEnd"
           @pointercancel="onResizeEnd"
           @dblclick="resetColWidth('list')"></div>
      <div class="v2026-col-main" v-if="!useExtractedMainPanel">
        <template v-if="selectedConversation">
          <customer-information ref="infoBox" @clearConversation="clearConversation" @clearReminder="clearReminder"
                                @toggleCustomerInfo="toggleCustomerInfo" :selectedConversation="selectedConversation"/>
          <div class="message-display py-4" id="messageDisplay" ref="messageDisplay"
               :style="`height:${messageDisplayHeight}px;`" @scroll.passive="handleMessageScroll" v-if="messages">
            <div v-for="(message, index) in messages" :key="message.id || 'loading-' + index">
              <template v-if="message.id > 0">
                <customer-chat
                :message="message"
                :selectedFile="selectedFile"
                @onSelectAttachmentFile="selectedAttachmentFile"
                @onSelectAttachment="openImage"
                v-if="message.own === 0"/>
                <admin-chat
                :message="message"
                :selectedFile="selectedFile"
                @onSelectAttachmentFile="selectedAttachmentFile"
                @onSelectAttachment="openImage"
                v-else/>
              </template>
              <template v-else>
                <div class="pb-4 text-center">
                  <i class="fas fa-spinner fa-pulse"></i> Loading...
                </div>
              </template>
            </div>
          </div>
          <template  v-if="selectedFile.length > 0">
            <div class="d-flex justify-content-center align-items-center" style="gap: 5px;">
              <button @click="downloadSelectedFilesV2" class="download-button capitalize">
                ดาวน์โหลดไฟล์ ({{ selectedFile.length }})
              </button>
            </div>
          </template>
          <message-box ref="messageBox" :selectedConversation="selectedConversation"></message-box>
        </template>
        <div class="v2026-empty" v-else>
          <img src="https://beneat.co/static/img/main-logo.svg" alt="BeNeat">
          <p>เลือกแชทที่คุณต้องการสนทนา</p>
        </div>
      </div>
      <main-panel-v2026 v-else
                        ref="mainPanel"
                        :selectedConversation="selectedConversation"
                        :messages="messages"
                        :selectedFile="selectedFile"
                        :messageDisplayHeight="messageDisplayHeight"
                        :incognitoActive="incognitoActive"
                        :incognitoConversation="incognitoConversation"
                        :incognitoMessages="incognitoMessages"
                        :incognitoLoading="incognitoLoading"
                        @clearConversation="clearConversation"
                        @clearReminder="clearReminder"
                        @toggleCustomerInfo="toggleCustomerInfo"
                        @messageScroll="handleMessageScroll"
                        @selectAttachmentFile="selectedAttachmentFile"
                        @selectAttachment="openImage"
                        @downloadFiles="downloadSelectedFilesV2"
                        @incognitoScroll="handleIncognitoScroll"
                        @closeStealth="closeStealthInline"></main-panel-v2026>
      <div class="v2026-resizer" role="separator" aria-orientation="vertical"
           aria-label="ปรับความกว้างแผงด้านขวา"
           title="ลากเพื่อปรับความกว้าง (ดับเบิลคลิกเพื่อรีเซ็ต)"
           v-if="useColumnResizer && admin && (selectedConversation || incognitoActive) && !aiPanelCollapsed"
           @pointerdown="onResizeStart('ai', $event)"
           @pointermove="onResizeMove"
           @pointerup="onResizeEnd"
           @pointercancel="onResizeEnd"
           @dblclick="resetColWidth('ai')"></div>
      <div class="v2026-col-ai" ref="colAi" :style="aiColStyle"
           :class="{ 'is-collapsed': aiPanelCollapsed }" v-if="admin && (selectedConversation || incognitoActive)">
        <button v-if="aiPanelCollapsed"
                class="v2026-ai-expand"
                @click="toggleAiPanel"
                :aria-label="aiPanelExpandLabel"
                :title="aiPanelExpandLabel">
          <span class="v2026-ai-expand-ico"></span>
        </button>
        <template v-if="!aiPanelCollapsed">
        <template v-if="!useExtractedMainPanel">
          <ai-assistant ref="aiAssistant"
                        :selectedConversation="selectedConversation"
                        v-if="(customerType === 'customer' || customerType === 'beneat_professional') && departmentIds.includes(admin.department_id)" >
                      <template v-slot:ai-title>ผู้ช่วย AI</template>
          </ai-assistant>
          <ai-assistant ref="aiAssistant"
                        :selectedConversation="selectedConversation"
                        v-if="(customerType === 'recruitment_customer' || customerType === 'recruitment_professional')&& departmentIds.includes(admin.department_id)" >
                      <template v-slot:ai-title>ผู้ช่วย AI แปลภาษา</template>
          </ai-assistant>
          <template v-if="customer && !customer.error">
            <customer-detail :customer="customer" :selectedConversation="selectedConversation"></customer-detail>
            <customer-note :customerDetail="customer" :selectedConversation="selectedConversation"></customer-note>
            <hr>
          </template>
        </template>
        <template v-else>
          <customer-panel-v2026 v-if="customerType === 'customer'"
                                :selectedConversation="panelConversation"
                                :customer="customer"
                                @toggleCollapse="toggleAiPanel" />
          <professional-panel-v2026 v-else-if="customerType === 'beneat_professional'"
                                :selectedConversation="panelConversation"
                                :customer="customer"
                                @toggleCollapse="toggleAiPanel" />
          <ApplicantPanelV2026 v-else-if="customerType === 'professional'"
                                :selectedConversation="panelConversation"
                                :customer="customer"
                                @toggleCollapse="toggleAiPanel" />
          <!-- :key is load-bearing: recruitment and Mari render the same tag in one v-if chain, so
               Vue patches instead of remounting and activeTab 4 would leak onto a Mari rail. -->
          <RecruitmentPanelV2026 v-else-if="showSharedRailPanel"
                                :key="sharedRailPanelKey"
                                :selectedConversation="panelConversation"
                                :customer="customer"
                                @toggleCollapse="toggleAiPanel" />
          <template v-else>
            <ai-assistant ref="aiAssistant"
                          :selectedConversation="panelConversation"
                          v-if="(customerType === 'recruitment_customer' || customerType === 'recruitment_professional')&& departmentIds.includes(admin.department_id)" >
                        <template v-slot:ai-title>ผู้ช่วย AI แปลภาษา</template>
            </ai-assistant>
            <template v-if="customer && !customer.error">
              <customer-detail :customer="customer" :selectedConversation="panelConversation"></customer-detail>
              <customer-note :customerDetail="customer" :selectedConversation="panelConversation"></customer-note>
              <hr>
            </template>
          </template>
        </template>
        </template><!-- /!aiPanelCollapsed -->
      </div>
      <div v-if="mobileNavOpen" class="v2026-mobile-backdrop v2026-mobile-backdrop--nav" @click="mobileNavOpen = false"></div>
      <div v-if="!aiPanelCollapsed" class="v2026-mobile-backdrop" @click="toggleAiPanel"></div>
    </div>
    <preview-image-modal ref="previewImageModal"></preview-image-modal>
    <phone-call-modal ref="phoneCallModal"></phone-call-modal>
    <!-- เคสของตัวเองถึงเวลาเตือน — ค้างจนกดปิด ไม่ให้พลาด -->
    <BaseToast :open="reminderToast.open"
               variant="danger"
               icon="alert"
               :title="reminderToast.title"
               :message="reminderToast.message"
               :autoHideDelay="0"
               :actionLabel="reminderToast.conversationId ? 'เปิดแชท' : ''"
               @action="openReminderToastChat"
               @close="reminderToast.open = false"/>
  </section>
</template>

<script>
import Vue from 'vue'
import { useFavicon, useTitle, useResizeObserver } from '@vueuse/core'
import { mapState, mapActions } from 'vuex'
import AdminChat from '@/components/coversation/AdminChat'
import AiAssistant from '@/components/aiAssistant/AiAssistant'
import CustomerChat from '@/components/coversation/CustomerChat'
import CustomerInformation from '@/components/coversation/CustomerInformation'
import CustomerNote from '@/components/coversation/CustomerNote'
import CustomerDetail from '@/components/coversation/CustomerDetail'
import MessageBox from '@/components/coversation/MessageBox'
import PreviewImageModal from '@/components/modal/PreviewImageModal'
import PhoneCallModal from '@/components/coversation/PhoneCallModal.vue'
import QueueMenuV2026 from '@/components/coversation/QueueMenuV2026.vue'
import BaseToast from '@/components/coversation/BaseToast.vue'
import InboxToolbarV2026 from '@/components/coversation/InboxToolbarV2026.vue'
import ChatCardV2026 from '@/components/coversation/ChatCardV2026.vue'
import MainPanelV2026 from '@/components/coversation/MainPanelV2026.vue'
import CustomerPanelV2026 from '@/components/coversation/CustomerPanelV2026.vue'
import ProfessionalPanelV2026 from '@/components/coversation/ProfessionalPanelV2026.vue'
import ApplicantPanelV2026 from '@/components/coversation/ApplicantPanelV2026.vue'
import RecruitmentPanelV2026 from '@/components/coversation/RecruitmentPanelV2026.vue'
import chatHelpers from '@/helpers/chatHelpers'
import { withInboxSort } from '@/store/modules/conversation'
import axios from 'axios'
import moment from 'moment'

const V2026_HEADER_HEIGHT = 64

// "ข้อความที่ยังไม่ได้ตอบ" = ข้อความล่าสุดเป็นของลูกค้า หรือหลังจากนั้นมีแค่ bot / ข้อความระบบ
// ต้องตรงกับ where ฝั่ง server (chat-server/helpers/conversationHelper.js isNotResponse, keepPendingReply)
const isAwaitingReply = (conversation) => {
  const lastMessage = conversation && conversation.last_message
  return Boolean(lastMessage && (lastMessage.own === 0 || lastMessage.pending_reply === 1))
}

const V2026_AI_PANEL_EXPAND_LABEL_DEFAULT = 'แสดงแผงข้อมูลลูกค้า'
const V2026_AI_PANEL_EXPAND_LABELS = {
  customer: V2026_AI_PANEL_EXPAND_LABEL_DEFAULT,
  recruitment_customer: V2026_AI_PANEL_EXPAND_LABEL_DEFAULT,
  beneat_professional: 'แสดงแผงข้อมูลคุณแม่บ้าน',
  recruitment_professional: 'แสดงแผงข้อมูลคุณแม่บ้าน',
  recruitment_professional_secondary: 'แสดงแผงข้อมูลคุณแม่บ้าน',
  professional: 'แสดงแผงข้อมูลผู้สมัคร'
}
// Kept out of the map above on purpose: that button renders whatever the panel flags say, so
// a mari_* entry there would change the flag-OFF path. Read only when useMariPanel is on.
const V2026_MARI_EXPAND_LABELS = {
  mari_professional: 'แสดงแผงข้อมูลผู้สมัคร'
}

// ── DEMO: ลากปรับความกว้างคอลัมน์ ────────────────────────────────────────────
// ต่ำกว่านี้คอลัมน์กลายเป็น drawer ลอยทับ ลากไม่มีความหมาย
const COL_RESIZE_MIN_VIEWPORT = 820
// คนละค่าต่อคอลัมน์: queue เป็นเมนูล้วน ค่าเริ่มต้นแค่ 200 จะใช้ min เดียวกับอีกสองอันไม่ได้
const COL_MIN_WIDTH = { queue: 150, list: 240, ai: 240 }
// การ์ดแชทแบบย่อเมื่อคอลัมน์รายการ (border-box จริงที่วัดได้) แคบกว่านี้ — 300 พอดียังเป็นการ์ดปกติ
// วัดจาก DOM ไม่ใช่ listWidth เพราะ listWidth เป็น null จนกว่าจะลาก และไม่รู้ค่าจาก media query/drawer
const LIST_COMPACT_BELOW = 300
// กันที่ให้ห้องแชทเสมอ ตรงกับ min-width ของ .v2026-col-main
const COL_MAIN_MIN = 360
const COL_DEFAULT_WIDTH = { queue: 200, list: 360, ai: 320 }
const COL_WIDTH_KEY = 'v2026:col-widths'

function clampColWidth (kind, value, max) {
  const min = COL_MIN_WIDTH[kind]
  return Math.round(Math.min(Math.max(value, min), Math.max(min, max)))
}

export default {
  components: {
    BaseToast,
    AdminChat,
    AiAssistant,
    CustomerChat,
    CustomerInformation,
    CustomerNote,
    CustomerDetail,
    MessageBox,
    PreviewImageModal,
    PhoneCallModal,
    QueueMenuV2026,
    InboxToolbarV2026,
    ChatCardV2026,
    MainPanelV2026,
    CustomerPanelV2026,
    ProfessionalPanelV2026,
    ApplicantPanelV2026,
    RecruitmentPanelV2026
  },
  data () {
    return {
      useExtractedMainPanel: true,
      useRecruitmentPanel: true,
      useMariPanel: true,
      useLeftFirstCollapse: true,
      socketConnectedOnce: false,
      // แท็บย่อยของเมนูเตือนนัดหมาย: due = ถึงเวลาแล้ว, upcoming = รอเตือน (เข้าเมนูใหม่ = due เสมอ)
      reminderState: 'due',
      reminderBoundaryTimer: null,
      // toast เตือนเคสของตัวเอง: แจ้งเฉพาะเคสที่ remind_at ข้ามจาก "ยังไม่ถึง" ไป "ถึงแล้ว" ระหว่างเปิดหน้าอยู่
      // (เปิดหน้ามาทีหลังเวลาเตือน = ไม่ toast ย้อนหลัง ดูได้จากแท็บถึงเวลาแล้ว)
      reminderCheckedAt: new Date(),
      reminderToastedKeys: [],
      reminderToast: { open: false, title: '', message: '', conversationId: null },
      incognitoActive: false,
      incognitoConversation: null,
      incognitoMessages: [],
      incognitoLoading: false,
      incognitoPage: 0,
      incognitoContentHeight: 0,
      // true while the reader sits at the bottom; images that finish loading keep them there
      incognitoPinned: false,
      selectedFile: [],
      title: null,
      favicon: null,
      page: 0,
      selectedConversation: null,
      selectedAttachment: null,
      contentHeight: null,
      isSending: false,
      isLoadingMoreConversation: false,
      messageDisplayHeight: window.innerHeight - V2026_HEADER_HEIGHT,
      conversationDisplayHeight: 0,
      filteredRecruitmentMenuCount: null,
      queueCollapsed: false,
      viewportWidth: window.innerWidth,
      // false = กลับไปใช้ความกว้างคงที่จาก CSS ทั้งหมด ทั้งเส้นลากและค่าที่จำไว้ถูกปิดพร้อมกัน
      useColumnResizer: true,
      // null = ยังไม่เคยลาก ใช้ค่าจาก CSS (media query ยังทำงาน)
      queueWidth: null,
      listWidth: null,
      aiWidth: null,
      // false = การ์ดแชทปกติทุกความกว้าง (ปิดโหมดย่อทั้งหมด)
      useCompactCards: true,
      // มาจาก ResizeObserver บน .v2026-col-list เท่านั้น ห้ามตั้งค่าเอง
      listCompact: false,
      resizing: null,
      aiPanelCollapsed: false,
      mobileNavOpen: true, // mobile (≤820px) left drawer (queue + list). Desktop ignores it.
      searchConversationParams: {
        admin_id: null,
        page: 0,
        menu: 'inbox',
        keyword: null,
        tag_id: null,
        customer_type: 'customer',
        conversation_created_date: null,
        is_reminder: 0,
        is_emergency: 0,
        reminder_state: 'due', // server ใช้เฉพาะ menu = reminder
        filter_by_and_or: 0 // 1 = และ (AND), 0 = หรือ (OR)
      },
      aiAssistantAdminIds: []
    }
  },
  computed: {
    // rail กางแบบลอยทับ (overlay) ไม่กินพื้นที่คอลัมน์แล้ว จึงไม่ต้องบีบ — คืนค่าที่แอดมินลากไว้ตรง ๆ
    // (เท่ากับผลเดิมตอน rail ย่อ) คง computed ไว้เพื่อไม่ต้องแตะ *ColStyle ที่อ่านจากตัวนี้
    clampedColWidths () {
      return { queue: this.queueWidth, list: this.listWidth, ai: this.aiWidth }
    },
    queueColStyle () {
      // ตอนพับต้องไม่ใส่ inline style ไม่งั้นทับ .is-collapsed { flex-basis: 0 } แล้วพับไม่ลง
      if (!this.useColumnResizer || this.queueCollapsed || !this.clampedColWidths.queue) return {}
      return { flexBasis: this.clampedColWidths.queue + 'px' }
    },
    listColStyle () {
      if (!this.useColumnResizer || !this.clampedColWidths.list) return {}
      // ต้องเซ็ต maxWidth ด้วย เพราะ CSS ล็อก .v2026-col-list ไว้ที่ 380px
      return { flexBasis: this.clampedColWidths.list + 'px', maxWidth: this.clampedColWidths.list + 'px' }
    },
    aiColStyle () {
      // เหมือน queueColStyle: ตอนพับต้องไม่ใส่ inline style ไม่งั้นทับ .is-collapsed แล้วพับไม่ลง
      if (!this.useColumnResizer || this.aiPanelCollapsed || !this.clampedColWidths.ai) return {}
      return { flexBasis: this.clampedColWidths.ai + 'px' }
    },
    ...mapState('admin', ['admin']),
    ...mapState('aiAssistant', ['adminIds', 'departmentIds', 'visionRequest', 'fcRequest']),
    ...mapState('conversation', ['conversations', 'conversationsLoading', 'conversation', 'customerType', 'customer']),
    ...mapState('message', ['messages', 'performScroll']),
    ...mapState({
      menuCount: state => state.menu.menuCount,
      menuType: state => state.menu.type,
      navItem: state => state.menu.navItem
    }),
    // หัวรายการตามเมนูที่เลือก (เดิมเขียนตายตัว "ถาดขาเข้า" ทุกเมนู)
    listTitle () {
      const titles = {
        inbox: 'ถาดขาเข้า',
        reminder: 'เตือนนัดหมาย',
        active: 'กำลังให้บริการ',
        my_inbox: 'รับเคสแล้ว',
        resolved: 'ปิดเคส',
        line: 'Line',
        facebook: 'Facebook'
      }
      return titles[this.menuType] || 'ถาดขาเข้า'
    },
    reminderTabs () {
      const mc = this.menuCount
      const isProfessional = this.customerType === 'professional'
      const due = mc ? (isProfessional ? mc.reminderProfessionalDueCount : mc.reminderCustomerDueCount) : 0
      const upcoming = mc ? (isProfessional ? mc.reminderProfessionalUpcomingCount : mc.reminderCustomerUpcomingCount) : 0
      return [
        { value: 'due', label: 'ถึงเวลาแล้ว', count: due || 0 },
        { value: 'upcoming', label: 'รอเตือน', count: upcoming || 0 }
      ]
    },
    panelConversation () {
      return this.selectedConversation || this.incognitoConversation
    },
    // Two values each, on purpose. The other rails sharing the legacy fallback
    // (recruitment_professional_secondary, professional_secondary, sales_product_customer) keep it.
    isRecruitmentPanelRail () {
      return this.customerType === 'recruitment_customer' ||
        this.customerType === 'recruitment_professional'
    },
    isMariPanelRail () {
      return this.customerType === 'mari_customer' ||
        this.customerType === 'mari_professional'
    },
    showSharedRailPanel () {
      return (this.useRecruitmentPanel && this.isRecruitmentPanelRail) ||
        (this.useMariPanel && this.isMariPanelRail)
    },
    sharedRailPanelKey () {
      return this.isMariPanelRail ? 'mari' : 'recruit'
    },
    aiPanelExpandLabel () {
      if (this.useMariPanel && V2026_MARI_EXPAND_LABELS[this.customerType]) {
        return V2026_MARI_EXPAND_LABELS[this.customerType]
      }
      return V2026_AI_PANEL_EXPAND_LABELS[this.customerType] || V2026_AI_PANEL_EXPAND_LABEL_DEFAULT
    }
  },
  watch: {
    performScroll () {
      if (this.performScroll) {
        setTimeout(() => {
          if (this.useExtractedMainPanel) {
            const messageDisplay = this.$refs.mainPanel && this.$refs.mainPanel.getMessageScrollEl()
            if (!messageDisplay) {
              return
            }
            if (this.page === 0) {
              messageDisplay.scrollTop = messageDisplay.scrollHeight
            } else {
              messageDisplay.scrollTop =
                messageDisplay.scrollHeight - this.contentHeight
            }
            return
          }
          if (this.page === 0) {
            this.$refs.messageDisplay.scrollTop = this.$refs.messageDisplay.scrollHeight
          } else {
            this.$refs.messageDisplay.scrollTop =
              this.$refs.messageDisplay.scrollHeight - this.contentHeight
          }
        }, 250)
      }
    },
    // ออกจากเมนูเตือนนัดหมาย = กลับมาครั้งหน้าเริ่มที่ "ถึงเวลาแล้ว"
    menuType (menu) {
      if (menu !== 'reminder' && this.reminderState !== 'due') {
        this.reminderState = 'due'
        this.searchConversationParams.reminder_state = 'due'
      }
    },
    menuCount () {
      this.scheduleReminderBoundary()
      if (this.menuCount) {
        const sumCount =
          this.menuCount.inboxCustomerCount +
          this.menuCount.inboxProfessionalCount
        if (this.favicon && this.title) {
          if (sumCount > 0) {
            this.favicon.value = '/images/beneat-chat-active-favicon.png'
            this.title.value = `(${sumCount}) BeNeat Chat`
          } else {
            this.favicon.value = '/images/beneat-chat-favicon.png'
            this.title.value = `BeNeat Chat`
          }
        }
      }
    },
    // The whole right column is v-if'd on the collapse flag, so a collapsed panel would never see
    // the press. Expanding it here lets the panel's own watcher (or its mounted) do the tab switch.
    visionRequest () {
      if (this.visionRequest) this.aiPanelCollapsed = false
    },
    fcRequest () {
      if (this.fcRequest) this.aiPanelCollapsed = false
    },
    // Switching the left rail clears the whole chat channel so no stale view survives. Fires only
    // on change, so a deep-linked /conversations/:id load on mount is untouched.
    navItem () {
      if (this.incognitoActive) {
        this.closeStealthInline()
      }
      if (this.selectedConversation) {
        this.selectedConversation = null
        this.$store.commit('message/SET_MESSAGES', [])
        this.$router.replace({ path: `/conversations/` }).catch(() => {})
      }
    }
  },
  methods: {
    // offsetWidth = border-box แบบเดียวกับ COL_*_WIDTH ตัว scrollbar ในรายการไม่มีผลต่อโหมด
    // กว้าง 0 = คอลัมน์ถูกซ่อน (display:none) ข้ามไปเลย ค่าเดิมคงไว้จนกว่าจะแสดงอีกครั้ง
    updateListCompact () {
      const el = this.$refs.colList
      const width = el ? el.offsetWidth : 0
      if (!width) return
      this.listCompact = width < LIST_COMPACT_BELOW
    },
    onResizeStart (kind, ev) {
      if (window.innerWidth <= COL_RESIZE_MIN_VIEWPORT) return
      ev.preventDefault()
      const area = this.$refs.workarea
      const list = this.$refs.colList
      const ai = this.$refs.colAi
      const queue = this.$refs.colQueue
      this.resizing = {
        kind,
        startX: ev.clientX,
        startQueue: queue ? queue.offsetWidth : 0,
        startList: list ? list.offsetWidth : COL_DEFAULT_WIDTH.list,
        startAi: ai ? ai.offsetWidth : 0,
        areaW: area ? area.offsetWidth : 0
      }
      if (ev.target.setPointerCapture) ev.target.setPointerCapture(ev.pointerId)
    },
    onResizeMove (ev) {
      const r = this.resizing
      if (!r) return
      const delta = ev.clientX - r.startX
      // เพดานคือพื้นที่ที่เหลือหลังกันที่ให้ห้องแชทขั้นต่ำไว้แล้ว
      const free = r.areaW - COL_MAIN_MIN
      if (r.kind === 'queue') {
        this.queueWidth = clampColWidth('queue', r.startQueue + delta, free - r.startList - r.startAi)
      } else if (r.kind === 'list') {
        this.listWidth = clampColWidth('list', r.startList + delta, free - r.startQueue - r.startAi)
      } else {
        this.aiWidth = clampColWidth('ai', r.startAi - delta, free - r.startQueue - r.startList)
      }
    },
    onResizeEnd (ev) {
      if (!this.resizing) return
      this.resizing = null
      if (ev.target.releasePointerCapture && ev.target.hasPointerCapture && ev.target.hasPointerCapture(ev.pointerId)) {
        ev.target.releasePointerCapture(ev.pointerId)
      }
      this.saveColWidths()
    },
    resetColWidth (kind) {
      if (kind === 'queue') this.queueWidth = null
      else if (kind === 'list') this.listWidth = null
      else this.aiWidth = null
      this.saveColWidths()
    },
    saveColWidths () {
      try {
        window.localStorage.setItem(COL_WIDTH_KEY, JSON.stringify({
          queue: this.queueWidth, list: this.listWidth, ai: this.aiWidth
        }))
      } catch (e) { /* โหมดส่วนตัว / เก็บไม่ได้ ก็แค่ไม่จำ */ }
    },
    loadColWidths () {
      try {
        const raw = window.localStorage.getItem(COL_WIDTH_KEY)
        if (!raw) return
        const saved = JSON.parse(raw)
        if (!saved) return
        if (typeof saved.queue === 'number') this.queueWidth = clampColWidth('queue', saved.queue, Infinity)
        if (typeof saved.list === 'number') this.listWidth = clampColWidth('list', saved.list, Infinity)
        if (typeof saved.ai === 'number') this.aiWidth = clampColWidth('ai', saved.ai, Infinity)
      } catch (e) { /* ค่าเสีย ใช้ default */ }
    },
    ...mapActions('admin', ['fetchAdmins', 'fetchPermissions', 'checkPermissions']),
    ...mapActions('aiAssistant', ['fetchAdminIds']),
    ...mapActions('conversation', ['fetchConversations', 'fetchConversation', 'searchCustomer', 'closeConversation']),
    ...mapActions('message', ['fetchMessages']),
    ...mapActions('menu', ['fetchMenuCount']),
    ...mapActions('tag', ['fetchTags', 'fetchSystemTags']),
    ...mapActions('coordination', ['fetchCoordination']),
    // Below the 1304 exact fit the queue's 200px has to come from somewhere, so a manual expand
    // folds the panel rather than overflowing.
    toggleQueueCollapse () {
      const wasCollapsed = this.queueCollapsed
      this.queueCollapsed = !this.queueCollapsed
      if (this.useLeftFirstCollapse && wasCollapsed && this.ladderWidth() < 1304) {
        this.aiPanelCollapsed = true
      }
    },
    toggleAiPanel () {
      this.aiPanelCollapsed = !this.aiPanelCollapsed
    },
    updateCountOfActiveMenu (value) {
      this.$refs.mainMenu.updateActiveMenuCount(value)
    },
    toggleCustomerInfo () {
      this.calculateMessageDisplayHeight()
    },
    moment (date) {
      return moment(date)
    },
    clearReminder () {
      if (this.useExtractedMainPanel) {
        if (this.$refs.mainPanel) {
          this.$refs.mainPanel.setReminder('')
        }
        return
      }
      this.$refs.messageBox.remindAt = ''
    },
    async handleMessageScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop === 0 && this.messages && this.messages.length > 0) {
        this.contentHeight = scrollHeight
        if (this.selectedConversation) {
          await this.loadMoreMessages(this.selectedConversation.id)
        }
      }
    },
    async handleConversationScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 5 && !this.isLoadingMoreConversation) {
        this.isLoadingMoreConversation = true
        this.searchConversationParams.page += 1
        await this.fetchConversations(this.searchConversationParams)
        this.isLoadingMoreConversation = false
      }
    },
    openImage (attachment) {
      if (attachment) {
        this.selectedAttachment = attachment
        const ext = chatHelpers.getUrlExtension(attachment.url)
        if (['jpg', 'jpeg', 'png', 'gif'].indexOf(ext) >= 0) {
          this.$refs.previewImageModal.open(attachment.url)
        }
      }
    },
    selectedAttachmentFile (attachment, isChecked) {
      if (isChecked) {
        this.selectedFile.push(attachment)
      } else {
        this.selectedFile = this.selectedFile.filter(item => item !== attachment)
      }
      const urlList = this.selectedFile.map(file => file.url)
      console.log('Selected files :', urlList)
    },
    async downloadSelectedFiles () {
      if (this.selectedFile.length === 0) {
        this.$swal({ text: 'กรุณาเลือกไฟล์ที่ต้องการดาวน์โหลด', icon: 'warning' })
        return
      }
      const urlList = this.selectedFile.map(file => file.url)
      for (const url of urlList) {
        if (url) {
          const link = document.createElement('a')
          link.href = url
          const uniqueName = 'download_chat_' + Date.now()
          link.download = uniqueName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          await new Promise(resolve => setTimeout(resolve, 500))
        }
      }
      this.selectedFile = []
      window.location.reload()
    },
    async downloadSelectedFilesV2 () {
      this.loadingDowloadFile = true
      if (this.selectedFile.length === 0) {
        this.$swal.fire({ text: 'กรุณาเลือกไฟล์ที่ต้องการดาวน์โหลด', icon: 'warning' })
        return
      }
      if (this.selectedFile.length === 1) {
        const file = this.selectedFile[0]
        if (file.url) {
          const link = document.createElement('a')
          link.href = file.url
          link.target = '_blank'
          link.download = file.name || 'download_file'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
        this.loadingDowloadFile = false
      } else {
        let newformantData = this.newFormatDownloadFile(this.selectedFile)
        await this.ApiDonwloadFiles(newformantData)
      }
      this.selectedFile = []
    },
    newFormatDownloadFile (files) {
      return files.map(file => ({
        id: file.id,
        url: file.url,
        name: file.name || file.url.split('/').pop()
      }))
    },
    async ApiDonwloadFiles (data) {
      window.open(`${Vue.prototype.$apiUrl}/download-files?data=${encodeURIComponent(JSON.stringify(data))}`)
      this.loadingDowloadFile = false
    },
    isRecruitmentCustomerType (customerType = this.customerType) {
      return ['recruitment_customer', 'recruitment_professional', 'recruitment_professional_secondary'].includes(customerType)
    },
    getRecruitmentConversationDate (createdAt) {
      const conversationDate = moment(createdAt)
      if (!conversationDate.isValid()) {
        return null
      }

      return conversationDate.hour() >= 17
        ? conversationDate.add(1, 'day').format('YYYY-MM-DD')
        : conversationDate.format('YYYY-MM-DD')
    },
    matchesSelectedConversationDate (conversation, params = this.searchConversationParams) {
      const selectedDate = params && params.conversation_created_date
      const customerType = params && params.customer_type
        ? params.customer_type
        : (conversation ? conversation.customer_type : null)
      if (!selectedDate || !conversation || !this.isRecruitmentCustomerType(customerType)) {
        return true
      }

      return this.getRecruitmentConversationDate(conversation.created_at) === selectedDate
    },
    async syncRecruitmentFilteredMenuCount (params) {
      if (
        !params ||
        !this.isRecruitmentCustomerType(params.customer_type) ||
        !params.conversation_created_date
      ) {
        this.filteredRecruitmentMenuCount = null
        return
      }

      params = params || this.searchConversationParams

      this.filteredRecruitmentMenuCount = await this.fetchMenuCount({
        params,
        commitToStore: false
      })
    },
    scrollToBottom (timeout) {
      if (this.useExtractedMainPanel) {
        const messageDisplay = this.$refs.mainPanel && this.$refs.mainPanel.getMessageScrollEl()
        if (messageDisplay) {
          setTimeout(() => {
            messageDisplay.scrollTop = messageDisplay.scrollHeight
          }, timeout)
        }
        return
      }
      if (this.$refs.messageDisplay) {
        setTimeout(() => {
          this.$refs.messageDisplay.scrollTop = this.$refs.messageDisplay.scrollHeight
        }, timeout)
      }
    },
    async searchConversation (searchData) {
      if (!searchData.hasOwnProperty('main_menu')) {
        this.searchConversationParams = {
          admin_id: null,
          page: 0,
          menu: this.menuType,
          keyword: null,
          tag_id: null,
          customer_type: this.customerType,
          conversation_created_date: null,
          assigned_within: null,
          reminder_state: this.reminderState
        }
        if (!searchData.hasOwnProperty('from_search')) {
          this.$refs['searchConversation'].clearSearch()
        }
      }

      for (let key in searchData) {
        this.searchConversationParams[key] = searchData[key]
      }
      // "รับเคสแล้ว" = เคสของตัวเองเสมอ ไม่ว่าตัวกรองแอดมินใน toolbar จะเป็นอะไร
      // (server case 'my_inbox' อ่าน admin_id จาก query เดียวกันนี้)
      if (this.searchConversationParams.menu === 'my_inbox' && this.admin) {
        this.searchConversationParams.admin_id = [this.admin.id]
      }
      await this.fetchConversations(this.searchConversationParams)
      await this.syncRecruitmentFilteredMenuCount(this.searchConversationParams)
    },
    async loadMoreMessages (conversationId) {
      const messageDisplayScroll = document.getElementById('messageDisplay')
      messageDisplayScroll.classList.add('overflow-hidden')
      this.page = this.page + 1
      const params = {
        conversation_id: conversationId,
        page: this.page
      }
      try {
        await this.fetchMessages(params)
      } catch (err) {
        this.$swal({ text: 'loadMoreMessages: ผิดพลาด ' + err.message, icon: 'error' })
      }
      messageDisplayScroll.classList.remove('overflow-hidden')
    },
    async loadFirstMessages (conversationId) {
      this.$store.commit('message/SET_MESSAGES', [])
      this.page = 0
      const params = {
        conversation_id: conversationId,
        page: this.page
      }
      await this.fetchMessages(params)
    },
    async loadConversationDetail (conversation) {
      this.mobileNavOpen = false
      if (this.incognitoActive) {
        this.closeStealthInline()
      }
      if (!this.selectedConversation || (this.selectedConversation && this.selectedConversation.id !== conversation.id)) {
        this.selectedConversation = conversation
        // The vision result is per-conversation and must never follow the admin to the next chat.
        this.$store.commit('aiAssistant/CLEAR_VISION')

        await this.$nextTick()

        if (this.useExtractedMainPanel) {
          if (this.$refs.mainPanel) {
            this.$refs.mainPanel.clearMessageBox()
          }
        } else if (this.$refs.messageBox) {
          this.$refs.messageBox.clearMessage()
        }
        console.log('message inbox')

        this.$router.replace({ path: `/conversations/${conversation.id}` })
        let params = {
          id: conversation.id,
          queryParams: {
            admin_id: this.admin.id
          }
        }
        await this.fetchConversation(params) // โหลดเฉพาะ conversation ที่มีการคลิก
        this.calculateMessageDisplayHeight()
        await this.loadFirstMessages(this.selectedConversation.id)
        if (conversation.customer) {
          params = {
            phone: conversation.customer.phone,
            email: conversation.customer.email,
            line_user_id: conversation.customer.lid,
            customer_id: conversation.customer.id,
            beneat_professional_id: conversation.customer.beneat_professional_id
          }
          this.searchCustomer(params)
        }
      }
    },
    async clearConversation () {
      let params = {
        admin_id: this.admin.id,
        conversation_id: this.selectedConversation.id
      }
      await this.closeConversation(params)

      this.selectedConversation = null
      this.$store.commit('aiAssistant/CLEAR_VISION')
      this.$router.replace({ path: `/conversations/` })
    },
    // Incognito must register NO read and NO presence: the target is never assigned to
    // selectedConversation and never fetched with admin_id. Entry also tears the normal view
    // down, so the two can never coexist and closing lands on the empty state.
    async openStealthInline (conversation) {
      this.mobileNavOpen = false
      this.selectedConversation = null
      this.$store.commit('message/SET_MESSAGES', [])
      this.$store.commit('aiAssistant/CLEAR_VISION')
      this.$router.replace({ path: `/conversations/` })

      this.stopIncognitoImagePin()
      this.incognitoConversation = conversation
      this.incognitoMessages = []
      this.incognitoPage = 0
      this.incognitoLoading = true
      this.incognitoActive = true
      if (conversation.customer) {
        this.searchCustomer({
          phone: conversation.customer.phone,
          email: conversation.customer.email,
          line_user_id: conversation.customer.lid,
          customer_id: conversation.customer.id,
          beneat_professional_id: conversation.customer.beneat_professional_id
        })
      }
      await this.fetchIncognitoMessages()
    },
    // Raw read-only GET, identical on the wire to ModalListChat's. Writes only to incognitoMessages.
    async fetchIncognitoMessages () {
      if (!this.incognitoConversation) {
        return
      }
      const params = {
        conversation_id: this.incognitoConversation.id,
        page: this.incognitoPage
      }
      try {
        const res = await axios.get('/messages', { params })
        if (res.status === 200) {
          const messages = res.data
          if (messages.length > 0) {
            this.incognitoMessages =
              this.incognitoPage === 0 ? messages : [...messages, ...this.incognitoMessages]
            // the list only renders once loading is off; scrolling before that measures the spinner
            this.incognitoLoading = false
            await this.$nextTick()
            const el = this.$refs.mainPanel && this.$refs.mainPanel.getMessageScrollEl()
            if (el) {
              el.scrollTop =
                this.incognitoPage === 0
                  ? el.scrollHeight
                  : el.scrollHeight - this.incognitoContentHeight
              if (this.incognitoPage === 0) {
                this.incognitoPinned = true
                this.startIncognitoImagePin(el)
              }
            }
          }
        }
      } catch (error) {
        this.$swal('Error', error.message, 'error')
      } finally {
        this.incognitoLoading = false
      }
    },
    // Images load after the first scroll and push the bottom away. load does not bubble, so one
    // capture listener on the list catches every image; it only re-pins while the reader has not
    // scrolled up.
    startIncognitoImagePin (el) {
      const onLoad = (event) => {
        if (event.target.tagName === 'IMG' && this.incognitoPinned) {
          el.scrollTop = el.scrollHeight
        }
      }
      el.addEventListener('load', onLoad, true)
      this.incognitoImagePinStop = () => el.removeEventListener('load', onLoad, true)
    },
    stopIncognitoImagePin () {
      if (this.incognitoImagePinStop) {
        this.incognitoImagePinStop()
        this.incognitoImagePinStop = null
      }
    },
    async handleIncognitoScroll ({ target: { scrollTop, scrollHeight, clientHeight } }) {
      this.incognitoPinned = scrollHeight - scrollTop - clientHeight < 50
      if (scrollTop === 0 && this.incognitoConversation) {
        this.incognitoContentHeight = scrollHeight
        this.incognitoPage = this.incognitoPage + 1
        await this.fetchIncognitoMessages()
      }
    },
    // Clears incognito state ONLY. Must not POST close-conversation — nothing was ever opened.
    closeStealthInline () {
      this.stopIncognitoImagePin()
      this.incognitoPinned = false
      this.incognitoActive = false
      this.incognitoConversation = null
      this.incognitoMessages = []
      this.incognitoPage = 0
      this.incognitoContentHeight = 0
      this.incognitoLoading = false
    },
    setMenuCount (menuCount) {
      this.$store.commit('menu/SET_MENU_COUNT', menuCount)
    },
    calculateMessageDisplayHeight () {
      const navBarHeight = V2026_HEADER_HEIGHT
      let infoBoxHeight
      let messageBoxHeight
      if (this.useExtractedMainPanel) {
        if (!this.$refs.mainPanel || !this.$refs.mainPanel.isPanelReady()) {
          return
        }
        infoBoxHeight = this.$refs.mainPanel.getInfoBoxHeight()
        messageBoxHeight = this.$refs.mainPanel.getMessageBoxHeight()
      } else {
        if (!this.$refs.infoBox || !this.$refs.messageBox) {
          return
        }
        infoBoxHeight = this.$refs.infoBox.$el.clientHeight
        messageBoxHeight = this.$refs.messageBox.$el.clientHeight
      }
      this.messageDisplayHeight = window.innerHeight - navBarHeight - (infoBoxHeight + messageBoxHeight)
      if (this.$refs.searchConversation) {
        this.conversationDisplayHeight = this.$refs.searchConversation.$el.clientHeight + navBarHeight
      }
    },
    resizeHandler (e) {
      this.calculateMessageDisplayHeight()
    },
    // Ladder: 1304 queue folds · 1200 list trims (CSS) · 1080 queue+list enter the drawer ·
    // 820 panel folds to its rail. `<=` mirrors the CSS max-width queries exactly — a strict `<`
    // at 1080 would collapse the queue to zero HEIGHT inside the drawer on that one pixel.
    // rail กางแบบลอยทับ พื้นที่ของ rail คงที่ 64px เสมอ ladder จึงคิดจาก innerWidth ตรง ๆ
    ladderWidth () {
      return window.innerWidth
    },
    applyResponsiveCollapse () {
      this.viewportWidth = window.innerWidth
      const w = this.ladderWidth()
      if (this.useLeftFirstCollapse) {
        if (w <= 1080) {
          this.queueCollapsed = false
          this.aiPanelCollapsed = w <= 820
        } else {
          this.queueCollapsed = w < 1304
          this.aiPanelCollapsed = false
        }
        return
      }
      if (w <= 820) {
        this.queueCollapsed = false
        this.aiPanelCollapsed = true
      } else {
        this.aiPanelCollapsed = w < 1280
        this.queueCollapsed = w < 1080
      }
    },
    async selectReminderState (state) {
      if (state === this.reminderState) {
        return
      }
      this.reminderState = state
      this.searchConversationParams.reminder_state = state
      this.searchConversationParams.page = 0
      if (this.$refs.conversationDisplay) {
        this.$refs.conversationDisplay.scrollTop = 0
      }
      await this.fetchConversations(this.searchConversationParams)
    },
    // เคสย้ายจาก "รอเตือน" ไป "ถึงเวลาแล้ว" เพราะเวลาผ่านไปเฉย ๆ — ไม่มี socket event ให้ฟัง
    // server ส่ง nextReminderAt มากับ menuCount → ตั้ง timer ไว้ถึงเวลานั้นแล้วดึงตัวเลข (+ รายการถ้าอยู่เมนูนี้) ใหม่
    scheduleReminderBoundary () {
      clearTimeout(this.reminderBoundaryTimer)
      this.reminderBoundaryTimer = null
      const next = this.menuCount && this.menuCount.nextReminderAt
      if (!next) {
        return
      }
      // +1 วินาทีให้ผ่านขอบ <= now ฝั่ง server แน่ ๆ, สุ่มอีก ≤ 3 วินาทีไม่ให้ทุกแท็บยิงพร้อมกัน
      // เพดาน 1 ชม. แล้วค่อยตั้งใหม่ (setTimeout เกิน ~24 วันจะยิงทันที)
      const delay = Math.min(moment(next).diff(moment()) + 1000 + Math.floor(Math.random() * 3000), 60 * 60 * 1000)
      this.reminderBoundaryTimer = setTimeout(this.onReminderBoundary, Math.max(delay, 1000))
    },
    async onReminderBoundary () {
      this.reminderBoundaryTimer = null
      this.notifyMyDueReminders()
      if (this.searchConversationParams.menu === 'reminder') {
        // เงียบ ๆ ไม่ล้างรายการก่อน + ดึงตัวเลขใหม่ (→ watcher menuCount ตั้ง timer รอบถัดไป)
        await this.refreshListAfterReconnect()
        return
      }
      try {
        const menuCount = await this.fetchMenuCount({ commitToStore: false })
        if (menuCount) {
          this.setMenuCount(menuCount)
        }
      } catch (err) {
        // ตัวเลขเมนูไม่ใช่งานหลัก — ตั้ง timer รอบหน้าจากค่าเดิม
        this.scheduleReminderBoundary()
      }
    },
    // หาเคสของตัวเอง (admin_id = ฉัน) ที่เพิ่งถึงเวลาเตือนตั้งแต่เช็กรอบก่อน แล้วขึ้น toast — ทุก rail (ไม่ส่ง customer_type)
    async notifyMyDueReminders () {
      if (!this.admin || !this.admin.id) {
        return
      }
      const since = this.reminderCheckedAt
      const now = new Date()
      this.reminderCheckedAt = now
      let conversations = []
      try {
        const { data } = await axios.get('/conversations', {
          params: { menu: 'reminder', reminder_state: 'due', admin_id: [this.admin.id], page: 0 }
        })
        conversations = (data && Array.isArray(data.conversations)) ? data.conversations : []
      } catch (err) {
        return // toast เป็นของแถม — พลาดรอบนี้ ให้รายการ/ตัวเลขเมนูเป็นตัวบอกแทน
      }
      // key รวม remind_at: เลื่อนเวลาเตือนเคสเดิมแล้วถึงอีกรอบ = เตือนใหม่ได้
      const fresh = conversations.filter(conversation => {
        if (Number(conversation.admin_id) !== Number(this.admin.id) || !conversation.remind_at) return false
        const remindAt = moment(conversation.remind_at)
        return remindAt.isAfter(since) && !remindAt.isAfter(now) &&
          !this.reminderToastedKeys.includes(conversation.id + '@' + conversation.remind_at)
      })
      if (fresh.length === 0) {
        return
      }
      this.reminderToastedKeys.push(...fresh.map(conversation => conversation.id + '@' + conversation.remind_at))
      const first = fresh[0]
      const name = (first.customer && first.customer.name) || 'ไม่ระบุชื่อ'
      // ปิดก่อนแล้วเปิดใน tick ถัดไป ให้ BaseToast เล่น transition ใหม่ถ้ามีอันเก่าค้างอยู่
      this.reminderToast.open = false
      await this.$nextTick()
      this.reminderToast = fresh.length === 1
        ? { open: true, title: 'ถึงเวลาเตือนนัดหมาย', message: name, conversationId: first.id }
        : { open: true, title: 'ถึงเวลาเตือนนัดหมาย ' + fresh.length + ' เคส', message: name + ' และอีก ' + (fresh.length - 1) + ' เคส', conversationId: null }
    },
    async openReminderToastChat () {
      const id = this.reminderToast.conversationId
      this.reminderToast.open = false
      if (id) {
        await this.fetchConversationFromQueryParams(id)
      }
    },
    // ผู้ใช้สั่งเอง (กดเมนูเดิมซ้ำ) — ล้างแล้วโหลดใหม่ให้เห็น "กำลังโหลด" ต่างจาก refreshListAfterReconnect ที่เงียบ
    async reloadCurrentMenu () {
      if (!this.searchConversationParams || !this.searchConversationParams.menu) {
        return
      }
      this.searchConversationParams.page = 0
      if (this.$refs.conversationDisplay) {
        this.$refs.conversationDisplay.scrollTop = 0
      }
      this.fetchMenuCount({ commitToStore: true })
      await this.fetchConversations(this.searchConversationParams)
    },
    // เงียบ ๆ ไม่ล้างรายการก่อน (fetchConversations page 0 ล้างก่อน = จอกระพริบ)
    async refreshListAfterReconnect () {
      if (!this.searchConversationParams || !this.searchConversationParams.menu) {
        return
      }
      const params = { ...this.searchConversationParams, page: 0 }
      try {
        const { data } = await axios.get('/conversations', { params: withInboxSort(params, this.$store.state.conversation.inboxSort) })
        // ระหว่างรอ ผู้ใช้อาจสลับเมนู/ตัวกรองไปแล้ว — ผลเก่าห้ามทับ
        if (this.searchConversationParams.menu !== params.menu || this.searchConversationParams.customer_type !== params.customer_type) {
          return
        }
        if (data && Array.isArray(data.conversations)) {
          this.searchConversationParams.page = 0
          this.$store.commit('conversation/SET_CONVERSATIONS', data.conversations)
        }
      } catch (err) {
        // รายการเดิมยังใช้ได้ — รอบต่อไปค่อยลองใหม่
      }
      this.fetchMenuCount({ commitToStore: true })
    },
    // ขอบเขตเดียวกับ server (conversationHelper case 'reminder' + reminder_state)
    matchesReminderState (conversation) {
      if (!conversation.remind_at) {
        return false
      }
      const isDue = !moment().isBefore(conversation.remind_at)
      const state = this.searchConversationParams.reminder_state
      if (state === 'due') return isDue
      if (state === 'upcoming') return !isDue
      return true
    },
    // admin_id ของตัวกรอง: v2026 ส่งเป็น array, UI เก่าส่งเป็นค่าเดียว — แปลงเป็น array ของตัวเลขเสมอ
    getAdminFilterIds () {
      const value = this.searchConversationParams.admin_id
      const ids = Array.isArray(value) ? value : (value ? [value] : [])
      return ids.map(id => Number(id)).filter(id => !Number.isNaN(id))
    },
    canUpdateLastMessage (conversation) {
      let count = 0
      if (conversation.customer_type === this.customerType) {
        if (!this.matchesSelectedConversationDate(conversation)) {
          return false
        }

        if (this.searchConversationParams.admin_id ||
            this.searchConversationParams.tag_id ||
            this.searchConversationParams.keyword ||
            this.searchConversationParams.unread ||
            this.searchConversationParams.is_not_response ||
            this.searchConversationParams.is_reminder ||
            this.searchConversationParams.is_emergency ||
            this.searchConversationParams.conversation_created_date) {
          // Every active filter must match, same as the server where
          const params = this.searchConversationParams
          const adminIds = this.getAdminFilterIds()
          const tagIds = Array.isArray(params.tag_id) ? params.tag_id : []
          // Server matches customer.name LIKE %keyword%, case-insensitive
          const keyword = params.keyword ? String(params.keyword).toLowerCase() : ''
          const customerName = conversation.customer && conversation.customer.name ? String(conversation.customer.name).toLowerCase() : ''
          const matchesAll = [
            !adminIds.length || adminIds.indexOf(Number(conversation.admin_id)) > -1,
            !tagIds.length || (conversation.tags || []).some(tag => tagIds.includes(tag.id)),
            !keyword || customerName.includes(keyword),
            params.unread !== 1 || conversation.unread_count >= 1,
            params.is_not_response !== 1 || isAwaitingReply(conversation),
            params.is_reminder !== 1 || Boolean(conversation.remind_at),
            params.is_emergency !== 1 || Boolean(conversation.is_emergency)
          ].every(Boolean)
          if (matchesAll) {
            count += 1
          }
        } else {
          switch (this.searchConversationParams.menu) {
            case 'inbox':
              if (!conversation.admin_id && !conversation.is_archived) {
                // พิจารณาเพิ่มเงื่อนไขงานด่วน เวลามี Chat ใหม่เข้ามา
                count += 1
                console.log('check count case 5')
              } else if (conversation.admin_id) {
                count += 1
                console.log('check count case 5-1')
              }
              break
            case 'active':
              if (conversation.admin_id && !conversation.is_archived) {
                // พิจารณาเพิ่มเงื่อนไขงานด่วน เวลามี Chat ใหม่เข้ามา
                count += 1
                console.log('check count case 6')
              }
              break
            case 'resolved':
              if (conversation.is_archived === 1) {
                count += 1
                console.log('check count case 7')
              }
              break
            case 'reminder':
              // ตรงกับ server: remind_at ตามแท็บย่อย (due <= now / upcoming > now)
              if (this.matchesReminderState(conversation)) {
                count += 1
              }
              break
            case 'line':
            case 'facebook':
              if (!conversation.is_archived) {
                count += 1
                console.log('check count case 9')
              }
              break
          }
        }
      }
      return (count > 0)
    },
    async fetchConversationFromQueryParams (id) {
      const url = `/conversations/${id}?admin_id=${this.admin.id}`
      const response = await axios.get(url)

      if (response.status === 200) {
        const compareCustomerTypes = this.admin.customer_types.types.indexOf(response.data.customer_type) > -1
        if (!compareCustomerTypes) {
          this.$swal({
            text: 'ผิดพลาด: คุณไม่มีสิทธิ์เข้าถึงบทสนทนานี้',
            icon: 'error'
          })
          return
        }
        let navName = 'conversation-'
        if (response.data.customer_type === 'beneat_professional') {
          navName += 'beneat-professional'
        } else {
          navName += response.data.customer_type
        }

        this.$store.commit('menu/SET_NAV_ITEM', navName)
        this.$store.commit('menu/SET_TYPE_MENU', response.data.main_menu)
        // ลิงก์ข้าม rail (เช่นแชทคุณแม่บ้านขณะค้างอยู่ที่ rail ลูกค้า) ทำให้ watcher navItem ทำงาน
        // และล้างแชทที่เปิดอยู่ + URL ทิ้ง — รอให้มันรันก่อนแล้วค่อยตั้งแชทจากลิงก์
        await this.$nextTick()
        this.selectedConversation = response.data

        this.$store.commit('conversation/SET_CUSTOMER_TYPE', this.selectedConversation.customer_type)
        await this.fetchTags({ include_count: false, customer_type: this.selectedConversation.customer_type, system: 0 })
        await this.fetchSystemTags({ customer_type: this.selectedConversation.customer_type, system: 1 })

        this.$refs.mainMenu.loadConversations(response.data.main_menu)

        await this.loadConversationDetail(this.selectedConversation)

        await this.loadFirstMessages(this.selectedConversation.id)
        this.calculateMessageDisplayHeight()
        if (this.selectedConversation.customer) {
          const params = {
            phone: this.selectedConversation.customer.phone,
            email: this.selectedConversation.customer.email,
            line_user_id: this.selectedConversation.customer.lid,
            customer_id: this.selectedConversation.customer.id,
            beneat_professional_id: this.selectedConversation.customer.beneat_professional_id
          }
          await this.searchCustomer(params)
        }
      }
    },
    checkRemovingConversation (conversation) {
      if (!conversation) {
        return
      }

      if (!this.matchesSelectedConversationDate(conversation)) {
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
        return
      }

      if (['inbox', 'active', 'my_inbox'].includes(this.searchConversationParams.menu) && conversation.is_archived) {
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
      } else if (this.searchConversationParams.menu === 'resolved' && !conversation.is_archived) {
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
      } else if (this.searchConversationParams.menu === 'reminder' && !this.matchesReminderState(conversation)) {
        // ยกเลิกเตือน หรือเลื่อนเวลาข้ามไปอีกแท็บย่อย (เช่นเลื่อนเคสที่ถึงเวลาแล้วออกไปอนาคต)
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
      }

      // "รับเคสแล้ว": ย้ายเคสไปให้คนอื่น / ปล่อยคืนถาด = ไม่ใช่งานของเราแล้ว
      if (this.searchConversationParams.menu === 'my_inbox' && this.admin && Number(conversation.admin_id) !== Number(this.admin.id)) {
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
      }

      if (this.searchConversationParams.is_reminder === 1 && !conversation.remind_at) {
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
      }

      // ตอบแล้ว = ไม่ใช่ "ข้อความที่ยังไม่ได้ตอบ" อีกต่อไป (ตรงกับ where ฝั่ง server ดู isAwaitingReply)
      if (this.searchConversationParams.is_not_response === 1 && !isAwaitingReply(conversation)) {
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
      }

      // คนอื่นรับเคสไปแล้ว ต้องหายจาก inbox ของทุกคน — ยกเว้นตอนกรองด้วยแอดมิน
      // เพราะตัวกรองนั้นทับ admin_id ของเมนู (chat-server conversationHelper.js getAdminIdWhere)
      const hasAdminFilter = this.getAdminFilterIds().length > 0
      if (!hasAdminFilter && this.searchConversationParams.menu === 'inbox' && conversation.admin_id) {
        this.$store.commit('conversation/REMOVE_CONVERSATION_FROM_LIST', conversation.id)
      }
    },
    checkValidCustomerTypes () {
      if (this.customerType) {
        this.searchConversationParams.customer_type = this.customerType
        if (this.admin && this.admin.customer_types && this.admin.customer_types.types && this.admin.customer_types.types.length > 0) {
          const compareCustomerTypes = this.admin.customer_types.types.indexOf(this.customerType) > -1
          if (!compareCustomerTypes) {
            let navItemCustomerTypes = this.navItem.replace('conversation-', '')
            navItemCustomerTypes = navItemCustomerTypes.replace('-', '_')

            let customerType = this.admin.customer_types.types.find(item => item === navItemCustomerTypes)
            if (customerType) {
              this.searchConversationParams.customer_type = customerType
            } else {
              customerType = this.admin.customer_types.types[0]
              this.searchConversationParams.customer_type = customerType
              const convertToNavItem = 'conversation-' + customerType.replace('_', '-')
              this.$store.commit('menu/SET_NAV_ITEM', convertToNavItem)
              this.$store.commit('conversation/SET_CUSTOMER_TYPE', customerType)
              this.fetchTags({ include_count: false, customer_type: customerType, system: 0 })
            }
          }
        }
      }
    }
  },
  async mounted () {
    this.loadColWidths()
    // ต้องเริ่มก่อน await แรก ไม่งั้น deep link ที่ความกว้างแคบจะเห็นการ์ดปกติแวบหนึ่งก่อน
    // เก็บ stop ไว้เรียกใน beforeDestroy: นอก setup() vueuse ถอด observer เองไม่ได้
    this.updateListCompact()
    this.listCompactObserver = useResizeObserver(this.$refs.colList, this.updateListCompact)
    this.favicon = useFavicon()
    this.title = useTitle()
    this.fetchMenuCount()
    this.checkValidCustomerTypes()
    if (this.admin && this.admin.id) {
      await this.fetchPermissions({ admin_id: this.admin.id, permissions: ['/stealth-mode-reading-chat'] })
      this.checkPermissions('/stealth-mode-reading-chat')
    }
    await this.fetchConversations({ ...this.searchConversationParams, ...{ admin_id_login: this.admin.id } })
    await this.syncRecruitmentFilteredMenuCount(this.searchConversationParams)
    this.$store.commit('conversation/SET_CONVERSATION', [])
    this.$store.commit('conversation/SET_CUSTOMER', null)
    this.$store.commit('message/SET_MESSAGES', [])
    // The whole store is persisted, so without this a result from another day survives a reload.
    this.$store.commit('aiAssistant/CLEAR_VISION')
    if (this.useExtractedMainPanel) {
      this.$store.commit('aiAssistant/CLEAR_FC')
      this.$store.commit('aiAssistant/CLEAR_MULTI_MESSAGES')
    }
    if (this.$route.params.id) {
      const conversationId = this.$route.params.id
      await this.fetchConversationFromQueryParams(conversationId)
    }

    useResizeObserver(this.$refs.searchConversation, (entries) => {
      this.calculateMessageDisplayHeight()
    })

    this.applyResponsiveCollapse()
    window.addEventListener('resize', this.applyResponsiveCollapse)
  },
  beforeDestroy () {
    clearTimeout(this.reminderBoundaryTimer)
    window.removeEventListener('resize', this.applyResponsiveCollapse)
    if (this.listCompactObserver) this.listCompactObserver.stop()
    this.stopIncognitoImagePin()
  },
  sockets: {
    async connect () {
      console.log('socket connected')
      if (this.selectedConversation) {
        await this.loadFirstMessages(this.selectedConversation.id)
      }
      // ต่อใหม่หลังหลุด: event ช่วงที่หลุดหายไปแล้ว — ดึงรายการ + ตัวเลขเมนูใหม่ให้ตรง server
      // (ครั้งแรกข้าม เพราะหน้าเพิ่งโหลดรายการเอง)
      if (this.socketConnectedOnce) {
        this.refreshListAfterReconnect()
      }
      this.socketConnectedOnce = true
    },
    disconnect () {
      console.log('socket disconnected')
    },
    testMessageToConversation (data) {
      console.log('testMessageToConversation', data)
    },
    fetchCaseCoordination (data) {
      if (data && this.selectedConversation && Number(data.conversation_id) === Number(this.selectedConversation.id)) {
        this.fetchCoordination(data.conversation_id)
      }
    },
    async updateShiftWorkAdmin (data) {
      if (data && data.shift_work_admin.admin_id === this.admin.beneat_admin_id) {
        await this.$store.commit('admin/ADD_PROPERTY_ADMIN', {
          key: 'shift_work_admin',
          value: data.shift_work_admin
        })
        await this.$store.commit('admin/ADD_PROPERTY_ADMIN', {
          key: 'shift_work_role',
          value: data.shift_work_admin.role
        })
      }
    },
    newMessage (data) {
      const conversation = data.conversation
      if (this.canUpdateLastMessage(conversation)) {
        this.$store.commit('conversation/UPDATE_LAST_MESSAGE', {
          conversation: conversation,
          message: data.message,
          menuType: this.searchConversationParams.menu,
          admin: this.admin,
          hasAdminFilter: this.getAdminFilterIds().length > 0
        })
      }
      if (this.selectedConversation && this.selectedConversation.id === conversation.id) {
        if (!conversation.remind_at && this.selectedConversation.remind_at) {
          this.clearReminder()
        }
        this.selectedConversation = conversation
        this.$store.commit('message/UPDATE_NEW_MESSAGE', data.message)
        this.scrollToBottom(500)
      }
      this.checkRemovingConversation(conversation)
      if (data.menuCount) {
        this.setMenuCount(data.menuCount)
      }
    },
    conversation (data) {
      const conversation = data.conversation

      if (this.conversations && this.conversations.length > 0 && conversation) {
        const indexConversation = this.conversations.findIndex(item => item.id === conversation.id)
        let conversationsAll = { ...this.conversations }
        if (conversationsAll[indexConversation]) {
          conversationsAll[indexConversation].conversation_admins = conversation.conversation_admins
        }

        conversationsAll = Object.values({ ...conversationsAll })

        const selectTags = this.$refs.searchConversation.selectedTags
        if (selectTags && selectTags.length > 0) {
          const hasTagOnSelected = conversation.tags.find((item) => {
            return selectTags.find(tag => tag.id === item.id) ? item : null
          })

          if (hasTagOnSelected) {
            if (indexConversation < 0) {
              conversationsAll.unshift(conversation)
            }
          } else {
            conversationsAll = conversationsAll.filter(item => item.id !== conversation.id)
          }
        }

        if (!this.matchesSelectedConversationDate(conversation)) {
          conversationsAll = conversationsAll.filter(item => item.id !== conversation.id)
        }

        this.$store.commit('conversation/SET_CONVERSATIONS', conversationsAll)
      }

      this.$store.commit('conversation/UPDATE_CONVERSATION', conversation)
      if (this.selectedConversation && conversation && this.selectedConversation.id === conversation.id) {
        this.selectedConversation = conversation
      }
      this.checkRemovingConversation(conversation)
      if (data.menuCount) {
        this.setMenuCount(data.menuCount)
      }
    },
    onError (data) {
      if (data) {
        const error = data.error
        const message = (data.message) ? data.message : null
        if (this.admin && message && message.admin_id === this.admin.id) {
          let text = 'Error: ไม่สามารถส่งข้อความได้'
          console.log('onError: ', data)
          if (error && error.message) {
            text = `Error: ${error.message}`
            if (error.message === 'Requested entity was not found.') {
              text = 'Error: ไม่สามารถส่งข้อความได้ เนื่องจากคุณแม่บ้านไม่ได้เข้าใช้งานแอพเป็นเวลานาน'
            }
          }
          this.$swal({ text, icon: 'error' })
        }
      }
    },
    protollcallData (data) {
      if (data) {
      }
    },
    conversationTags (data) {
      if (data) {
        const targetMenus = ['inbox', 'reminder', 'active']
        if (this.menuType && targetMenus.includes(this.menuType)) {
          this.$store.commit('tag/SET_SYSTEM_TAGS', data[this.menuType].tags)
          this.$store.commit('tag/SET_COUNT_TAGGED_CONVERSATION', data[this.menuType].countTaggedConversation)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v2026-workarea {
  display: flex;
  height: calc(100vh - var(--v2026-header-h));
  overflow: hidden;
  background: #f7f8fa;
}

.v2026-col-queue {
  flex: 0 0 200px;
  background: #ffffff;
  border-right: 1px solid #e9ecef;
  overflow: hidden;
  transition: flex-basis .2s ease, opacity .2s ease;
}

.v2026-col-queue.is-collapsed {
  flex-basis: 0;
  opacity: 0;
  border-right-width: 0;
}

.v2026-col-list {
  max-width: 380px;
  flex: 0 0 360px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--v2026-header-h));
  background: #f7f8fa;
  border-right: 1px solid #e9ecef;
}

.v2026-list-title {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding: 16px;
  font-size: 15px;
  font-weight: 600;
  color: #212529;
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
}

.v2026-reminder-tabs {
  display: flex;
  flex: 0 0 auto;
  gap: 4px;
  padding: 8px 16px 0;
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
}

.v2026-reminder-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  margin-bottom: -1px;
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  background: none;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;

  &:hover {
    color: #212529;
  }

  &.is-active {
    color: #212529;
    border-bottom-color: var(--v2026-color-main);
  }
}

.v2026-reminder-tab-count {
  font-weight: 700;
  color: var(--v2026-color-icon-idle);
}

// ถึงเวลาแล้ว = ต้องทำ → สีแดงเดียวกับตัวเลขเมนู
.v2026-reminder-tab.is-due .v2026-reminder-tab-count {
  color: var(--v2026-color-count);
}

.v2026-queue-expand {
  padding: 0;
  margin-right: 8px;
  border: 0;
  background: none;
  cursor: pointer;
  line-height: 0;

  &:hover .v2026-queue-expand-ico {
    background-color: #212529;
  }
}

.v2026-queue-expand-ico {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #66696c;
  -webkit-mask: url('~@/assets/icons2026/arrow-right.svg') center / contain no-repeat;
  mask: url('~@/assets/icons2026/arrow-right.svg') center / contain no-repeat;
  transform: rotate(180deg);
}

.v2026-list-toolbar {
  flex: 0 0 auto;
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
}

.v2026-list-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
}

/* DEMO: เส้นลากปรับความกว้าง — เส้นบาง แต่ hit area กว้างกว่าด้วย ::before */
.v2026-resizer {
  flex: 0 0 5px;
  position: relative;
  align-self: stretch;
  cursor: col-resize;
  background: transparent;
  touch-action: none;
  z-index: 5;
}

.v2026-resizer::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: -3px;
  right: -3px;
}

.v2026-resizer::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 2px;
  width: 1px;
  background: transparent;
  transition: background-color .15s ease;
}

.v2026-resizer:hover::after,
.v2026-workarea.is-resizing .v2026-resizer::after {
  background: var(--v2026-color-main, #31C1D7);
}

/* ระหว่างลาก: transition ของคอลัมน์ต้องปิด ไม่งั้นเส้นตามเมาส์ไม่ทัน + กันลากแล้วเลือกข้อความติดมา */
.v2026-workarea.is-resizing {
  user-select: none;
}

.v2026-workarea.is-resizing .v2026-col-queue,
.v2026-workarea.is-resizing .v2026-col-ai {
  transition: none;
}

.v2026-workarea.is-resizing ::v-deep * {
  cursor: col-resize !important;
}

@media (max-width: 820px) {
  .v2026-resizer { display: none; }
}

.v2026-col-main {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-width: 360px;
  background: #ffffff;
}

@media (max-width: 1200px) {
  .v2026-col-list {
    flex-basis: 300px;
    max-width: 300px;
  }
}

.v2026-mobile-nav { display: contents; }
.v2026-mobile-nav-handle,
.v2026-mobile-backdrop { display: none; }
.v2026-mobile-nav-handle-ico,
.v2026-mobile-nav-handle-label { display: none; }

@media (max-width: 820px) {
  .v2026-mobile-nav {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: var(--v2026-header-h);
    left: 64px;
    bottom: 0;
    width: calc(100vw - 64px);
    max-width: 360px;
    z-index: 1040;
    background: #ffffff;
    box-shadow: 4px 0 24px rgba(16, 24, 40, 0.15);
    transform: translateX(-105%);
    visibility: hidden;
    transition: transform 0.25s ease, visibility 0.25s;
  }
  .v2026-mobile-nav.is-open { transform: none; visibility: visible; }
  .v2026-mobile-nav .v2026-col-queue:not(.is-collapsed) {
    flex: 0 0 auto;
    border-right: 0;
    border-bottom: 1px solid #e9ecef;
  }
  .v2026-mobile-nav .v2026-col-queue:not(.is-collapsed) ::v-deep .v2026-queue { height: auto; }
  .v2026-mobile-nav .v2026-col-list {
    flex: 1 1 auto;
    max-width: none;
    height: auto;
    min-height: 0;
  }

  .v2026-col-main { min-width: 0; }

  .v2026-col-ai:not(.is-collapsed) {
    position: fixed;
    top: var(--v2026-header-h);
    right: 0;
    bottom: 0;
    width: calc(100vw - 64px);
    max-width: 360px;
    z-index: 1040;
    box-shadow: -4px 0 24px rgba(16, 24, 40, 0.15);
  }

  .v2026-mobile-nav-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 64px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 56px;
    border: 0;
    border-radius: 0 8px 8px 0;
    background: #ffffff;
    box-shadow: 2px 0 8px rgba(16, 24, 40, 0.15);
    color: #212529;
    font-size: 16px;
    cursor: pointer;
    z-index: 1030;
  }

  .v2026-mobile-backdrop {
    display: block;
    position: fixed;
    top: var(--v2026-header-h);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(16, 24, 40, 0.4);
    z-index: 1035;
  }
}

@media (max-width: 1080px) {
  .v2026-ladder-left-first .v2026-mobile-nav {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: var(--v2026-header-h);
    left: 64px;
    bottom: 0;
    width: calc(100vw - 64px);
    max-width: 360px;
    z-index: 1040;
    background: #ffffff;
    box-shadow: 4px 0 24px rgba(16, 24, 40, 0.15);
    transform: translateX(-105%);
    visibility: hidden;
    transition: transform 0.25s ease, visibility 0.25s;
  }
  .v2026-ladder-left-first .v2026-mobile-nav.is-open { transform: none; visibility: visible; }
  .v2026-ladder-left-first .v2026-mobile-nav .v2026-col-queue:not(.is-collapsed) {
    flex: 0 0 auto;
    border-right: 0;
    border-bottom: 1px solid #e9ecef;
  }
  .v2026-ladder-left-first .v2026-mobile-nav .v2026-col-queue:not(.is-collapsed) ::v-deep .v2026-queue { height: auto; }
  .v2026-ladder-left-first .v2026-mobile-nav .v2026-col-list {
    flex: 1 1 auto;
    max-width: none;
    height: auto;
    min-height: 0;
  }
  .v2026-ladder-left-first .v2026-mobile-nav-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 64px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 56px;
    border: 0;
    border-radius: 0 8px 8px 0;
    background: #ffffff;
    box-shadow: 2px 0 8px rgba(16, 24, 40, 0.15);
    color: #212529;
    font-size: 16px;
    cursor: pointer;
    z-index: 1030;
  }
  .v2026-ladder-left-first .v2026-mobile-backdrop--nav {
    display: block;
    position: fixed;
    top: var(--v2026-header-h);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(16, 24, 40, 0.4);
    z-index: 1035;
  }
}

@media (min-width: 821px) and (max-width: 1080px) {
  .v2026-ladder-left-first.v2026-workarea { padding-left: 40px; }
  .v2026-ladder-left-first .v2026-mobile-nav-handle {
    flex-direction: column;
    justify-content: flex-start;
    gap: 10px;
    top: var(--v2026-header-h);
    bottom: 0;
    transform: none;
    width: 40px;
    height: auto;
    padding: 14px 0 0;
    border-right: 1px solid #e9ecef;
    border-radius: 0;
    box-shadow: none;
  }
  .v2026-ladder-left-first .v2026-mobile-nav-handle-glyph { display: none; }
  .v2026-ladder-left-first .v2026-mobile-nav-handle-ico {
    display: block;
    width: 20px;
    height: 20px;
    background-color: #66696c;
    -webkit-mask: url('~@/assets/icons2026/inbox.svg') center / contain no-repeat;
    mask: url('~@/assets/icons2026/inbox.svg') center / contain no-repeat;
  }
  .v2026-ladder-left-first .v2026-mobile-nav-handle-label {
    display: block;
    writing-mode: vertical-rl;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    color: #66696c;
    white-space: nowrap;
  }
  .v2026-ladder-left-first .v2026-mobile-nav-handle:hover {
    background: var(--v2026-color-hover-bg);
  }
  .v2026-ladder-left-first .v2026-mobile-nav-handle:hover .v2026-mobile-nav-handle-ico {
    background-color: #212529;
  }
  .v2026-ladder-left-first .v2026-mobile-nav-handle:hover .v2026-mobile-nav-handle-label {
    color: #212529;
  }
  .v2026-ladder-left-first .v2026-mobile-nav-handle:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 3px rgba(49, 193, 215, 0.30);
  }
}

.v2026-col-ai {
  flex: 0 0 320px;
  height: calc(100vh - var(--v2026-header-h));
  overflow: hidden;
  background: #ffffff;
  border-left: 1px solid #e9ecef;
  transition: flex-basis .2s ease;
}

.v2026-col-ai.is-collapsed {
  flex: 0 0 40px;
}

.v2026-ai-expand {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 14px 0;
  border: 0;
  background: none;
  cursor: pointer;
  line-height: 0;

  &:hover .v2026-ai-expand-ico {
    background-color: #212529;
  }
}

.v2026-ai-expand-ico {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: #66696c;
  -webkit-mask: url('~@/assets/icons2026/arrow-right.svg') center / contain no-repeat;
  mask: url('~@/assets/icons2026/arrow-right.svg') center / contain no-repeat;
}

.v2026-empty {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - var(--v2026-header-h));
  background: #f7f8fa;
}

.v2026-empty img {
  width: 120px;
  opacity: 0.4;
  margin-bottom: 16px;
}

.v2026-empty p {
  font-size: 15px;
  color: #868e96;
}

.scrollable-y {
  height: calc(100vh - var(--v2026-header-h));
  overflow-y: scroll;
}

.overflow-hidden {
  overflow: hidden;
}

.download-button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.download-button:hover {
  background-color: #0056b3;
}
</style>
